export const ToolControls = [
  'Voyage_Consumption_Estimator',
  'Data_Export',
  'Fuel_Curves',
  'Wind_Assist_Experiments',
  'Voyage_Experiments',
  'Engine_Cooling_System_Optimization',
  'Charter_Party_Agreement',
  'Alarms_Monitoring_System',
  'Fuel_Levels',
  'Platooning_Tool',
  'Noon_Reports',
  'Multimodal_Route_Assessment',
  'vltn-simulations',
  'TCO_Calculator',
] as const;

export type ToolControlKey = (typeof ToolControls)[number];
